export default __webpack_public_path__ + "static/media/sales.07045475.webp";